export default __webpack_public_path__ + "static/networking_b.21800afc7fc66af5e1a1d7a5afaeb2a6.svg";